var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "07d0e7d2df3183f3c7cc02f65b8db63952fa1cc4"
};